import { createPortal } from 'react-dom';
import { GroupSheet } from './GroupSheet';
import { BracketPages } from './BracketPages';
import './competitionPrint.css';
import type {
  CompetitionBracketData,
  CompetitionDetail,
  CompetitionGroupsData,
} from '../../../types';

/**
 * Hidden, print-only A4 score sheets for a competition (group sheets + bracket).
 *
 * Mounted (invisible) on the detail page whenever an admin can print; portaled
 * to <body> so it sits outside the app's constrained/overflow-hidden layout.
 * The print stylesheet keeps it `display:none` on screen and reveals only these
 * sheets inside `@media print` when the admin triggers `window.print()`.
 */
export function PrintableSheets({
  detail,
  groups,
  bracket,
}: {
  detail: CompetitionDetail;
  groups: CompetitionGroupsData | null;
  bracket: CompetitionBracketData | null;
}) {
  const hasGroups = !!groups && groups.groups.length > 0;
  const hasBracket = !!bracket && bracket.rounds.length > 0;
  if (!hasGroups && !hasBracket) return null;

  return createPortal(
    <div className="tournament-print" aria-hidden="true">
      {hasGroups &&
        groups!.groups.map((group) => (
          <GroupSheet key={group.id} tournamentName={detail.name} group={group} />
        ))}
      {hasBracket && <BracketPages tournamentName={detail.name} bracket={bracket!} />}
    </div>,
    document.body
  );
}
